import React from 'react';
import { SecondaryButton } from '@magoosh/lib/button';
import { Form, Modal } from 'react-bootstrap';
import style from './style.module.scss';
import cx from 'classnames';
import Icon from '../../assets/icons';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';
import { useYourClassesContext } from '../../all_classes/context';
import { useUserContext } from '@magoosh/context/user_context';
import moment from 'moment-timezone';

export const RegistrationFormModal: React.FC = () => {
  const userData = useUserContext();

  const {
    openRegistrationFormModal,
    toggleOpenRegistrationFormModal,
    selectedClassData,
    formState,
    registerLiveClassSession,
    isRegisteringClass
  } = useYourClassesContext();

  const hasUserData = userData.firstName && userData.lastName && userData.email;
  const dateTime = selectedClassData && moment.utc(selectedClassData.dateTime).tz(moment.tz.guess());

  const handleOnSubmit = () => {
    registerLiveClassSession(selectedClassData.id);
  };

  const content = {
    register: {
      title: 'Register for This Class',
      description: 'You may attend live or watch the recording.',
      ctaCopy: 'Register',
      ctaOnClick: handleOnSubmit
    },
    registered: {
      title: 'You’re In!',
      description:
        'You may attend live or watch the recording. Check your email for a confirmation and add it to your calendar.',
      ctaCopy: 'Okay',
      ctaOnClick: () => {
        toggleOpenRegistrationFormModal(selectedClassData);
      }
    },
    updateProfile: {
      title: 'Update Your Profile to Register',
      description: 'You need a little more information in your account profile to register for a live class.',
      ctaCopy: 'Go To Account Profile',
      ctaOnClick: () => {
        window.location.href = paths.profileEdit();
      }
    }
  };

  return (
    <Modal
      className={cx(style.registrationFormModal, isRegisteringClass && style.isRegisteringClass)}
      show={openRegistrationFormModal}
      onHide={() => toggleOpenRegistrationFormModal(selectedClassData)}>
      <Form>
        <Modal.Header className={cx(style.header, 'u-padding-B-n')} closeButton>
          <h3>
            <strong>{content[!hasUserData ? 'updateProfile' : formState].title}</strong>
          </h3>
          <p className="u-margin-B-n">{content[!hasUserData ? 'updateProfile' : formState].description}</p>
        </Modal.Header>
        <Modal.Body>
          {formState === 'register' && hasUserData && selectedClassData && (
            <>
              <div className={cx(style.classBox, 'u-padding-A-m')}>
                <div className="u-margin-R-s">
                  <Icon iconType="DateAdd" color={style.brandPrimaryDarker} fill={style.brandPrimary} />
                </div>
                <div>
                  <p className="u-margin-A-n">
                    <strong>{selectedClassData.name}</strong>
                  </p>
                  <p>
                    <small>
                      {dateTime.isSame(moment(), 'day') ? 'Today' : dateTime.format('dddd, MMMM D')}
                    </small>{' '}
                    <small>{dateTime.format('LT z')}</small>
                  </p>
                  <p>{selectedClassData.description}</p>
                </div>
              </div>
              {isRegisteringClass && (
                <div className={style.spinner}>
                  <FontAwesomeIcon icon="spinner" className="fa-pulse fa-5x" />
                </div>
              )}
            </>
          )}

          {!hasUserData && (
            <div className={cx(style.messageBox, 'u-padding-A-m')}>
              <p>Please add the following required information to your account profile:</p>
              <p className="u-margin-A-n">
                {!userData.email && (
                  <>
                    <strong>Email</strong>
                    <br />
                  </>
                )}
                {!userData.firstName && (
                  <>
                    <strong>First Name</strong>
                    <br />
                  </>
                )}
                {!userData.lastName && (
                  <>
                    <strong>Last Name</strong>
                    <br />
                  </>
                )}
              </p>
            </div>
          )}

          <SecondaryButton
            disabled={isRegisteringClass}
            onClick={content[!hasUserData ? 'updateProfile' : formState].ctaOnClick}
            block={true}
            className="u-margin-T-m">
            {content[!hasUserData ? 'updateProfile' : formState].ctaCopy}
          </SecondaryButton>
        </Modal.Body>
      </Form>
    </Modal>
  );
};

export default RegistrationFormModal;
